export const FULFILMENT_SHIFT_FETCH_BEGIN = 'syftacp/FULFILMENT_SHIFT_FETCH_BEGIN' as const
export const FULFILMENT_SHIFT_FETCH_FAILED = 'syftacp/FULFILMENT_SHIFT_FETCH_FAILED' as const
export const FULFILMENT_SHIFT_FETCH_SUCCEEDED = 'syftacp/FULFILMENT_SHIFT_FETCH_SUCCEEDED' as const
export const FULFILMENT_SHIFT_EDIT_BEGIN = 'syftacp/FULFILMENT_SHIFT_EDIT_BEGIN' as const
export const FULFILMENT_SHIFT_EDIT_FAILED = 'syftacp/FULFILMENT_SHIFT_EDIT_FAILED' as const
export const FULFILMENT_SHIFT_EDIT_SUCCEEDED = 'syftacp/FULFILMENT_SHIFT_EDIT_SUCCEEDED' as const
